import {
	COMPOUND_OPERATOR_AND,
	JastBuilder,
	walkAST,
	creators,
	OPERATOR_EQUALS,
	print,
	type TerminalClause,
	OPERAND_EMPTY,
} from '@atlaskit/jql-ast';

export const replaceAssignee = (jql: string, assignee: string | null): string => {
	const ast = new JastBuilder().build(jql);

	let clause: TerminalClause | undefined;

	walkAST(
		{
			enterTerminalClause(terminalClause) {
				if (terminalClause.field.value.toLowerCase() === 'assignee') {
					clause = terminalClause;
				}
			},
		},
		ast,
	);

	if (assignee) {
		const newClause = creators.terminalClause(
			creators.field('assignee'),
			creators.operator(OPERATOR_EQUALS),
			assignee === 'unassigned'
				? creators.valueOperand(OPERAND_EMPTY)
				: creators.valueOperand(assignee),
		);

		if (clause) {
			clause.replace(newClause);
		} else {
			ast.query?.appendClause(newClause, COMPOUND_OPERATOR_AND);
		}
	} else if (clause) {
		clause.remove();
	}

	return print(ast, {
		operatorCase: 'upper',
	});
};
